import { AppState, KnightPosition } from "./Types";

export function chooseRandomEl(array: any[]) {
  return array[Math.floor(Math.random() * array.length)];
}

export function randInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function rollPosition(boardSize: number):KnightPosition {
  return {
    row: randInt(1, boardSize),
    col: randInt(1, boardSize)
  };
}

const moves = [
  [1, 2],
  [1, -2],
  [2, 1],
  [2, -1],
  [-1, 2],
  [-1, -2],
  [-2, 1],
  [-2, -1],
];

export function findPossibleMoves(appState: AppState) {

  let possible = moves.filter(
    (move) =>
      move[0] + appState.knightPosition.row <= appState.boardSize &&
      move[0] + appState.knightPosition.row > 0 &&
      move[1] + appState.knightPosition.col <= appState.boardSize &&
      move[1] + appState.knightPosition.col > 0 &&
      !JSON.stringify(appState.pastMoves).includes(JSON.stringify({
        row: move[0] + appState.knightPosition.row,
        col: move[1] + appState.knightPosition.col,
      }))
  );
  return possible.length > 0 ? possible : [];
}

export function valueText(value: number) {
  return `${1000-value} ms`;
}

export function valueRaw(value: number) {
  return`${value}`; 
}

export function simulateMovesAtTile(simState:AppState) {
  let moveCount = findPossibleMoves(simState)?.length;
  return (moveCount !== undefined) ? moveCount : 0;
}